import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import { createQueryString } from '_helpers/urls';
import { useRouter } from 'next/router';
import { ICONS_ALIASES } from '_constants/icons';

import Icon from '_components/atomic/Icon';
import Button from '_components/atomic/Button';

const { colors, devices } = theme;

const StyledRegisterYourLLCFloat = styled.div`
  z-index: 20;
  position: fixed;
  bottom: 30px;
  display: flex;
  justify-content: center;
  width: 40%;

  @media ${devices.tablet} {
    width: 100%;
    padding-left: 72px;
    padding-right: 72px;
    bottom: 16px;
  }
`;

const RegisterYourLLCFloat = () => {
  const router = useRouter();
  const [showBtn, setShowBtn] = useState(false);

  const goToFilling = useCallback(() => {
    router.push(
      `${ROUTES.llcIncorporationFiling}${createQueryString({
        step: 0,
      })}`,
      undefined,
      { shallow: true }
    );
  }, [router]);

  const handleScroll = () => {
    if (window.scrollY > 400) {
      setShowBtn(true);
    } else {
      setShowBtn(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledRegisterYourLLCFloat>
      {showBtn && (
        <Button
          suffix={
            <Icon alias={ICONS_ALIASES.arrowRight} color={colors.white} />
          }
          color={colors.orange[500]}
          onClick={goToFilling}
        >
          Form Your Free LLC Now
        </Button>
      )}
    </StyledRegisterYourLLCFloat>
  );
};

export default RegisterYourLLCFloat;
